import { FeatureHighlight } from "components/pricing/FeatureHighlight";
import {
  CollectionIcon,
  DocumentReportIcon,
  FlagIcon,
} from "@heroicons/react/outline";

const PricingFeatures = () => {
  return (
    <div>
      {/* Neg margin so this lines up with the pricing tiers */}
      <div className="container-xl py-32 md:pb-64 md:pt-80">
        <div className="lg:-mx-40">
          <div className="mx-auto grid gap-y-24 sm:gap-32 md:grid-cols-3 lg:ml-40 lg:gap-40">
            <FeatureHighlight
              Icon={FlagIcon}
              title="Annotate for free"
              description="Best-in-class annotation tools"
            />
            <FeatureHighlight
              Icon={CollectionIcon}
              title="14 day free trial"
              description="Try out the powerful model training features"
            />
            <FeatureHighlight
              Icon={DocumentReportIcon}
              title="Pricing scales with you"
              description="Pay only for your usage"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PricingFeatures;
